/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2021-12-27 14:42:17
 * @LastEditTime : 2022-06-14 13:45:06
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icpsNew\src\api\basicConfig\companyStandard.js
 */
import request from "@/utils/request";
/*获取强度等级和性能要求等。。。区分类型*/
export function getStrengthGtadeLists(data) {
  return request({
    url: "/icps/system/sign/basics/namingRule/getStrengthGtadeLists",
    method: "get",
    params:data,
  });
}
/*获取强度等级和性能要求等。。。*/
export function getLists(data) {
  return request({
    url: "/icps/system/sign/basics/namingRule/getLists",
    method: "post",
    data,
  });
}
/*获取列表。。。*/
export function queryList(data) {
  return request({
    url: "/icps/system/sign/basics/mixProportion/queryList",
    method: "post",
    data,
  });
}
/*新增修改。。。*/
export function saveOrUpdate(data) {
  return request({
    url: "/icps/system/sign/basics/mixProportion/saveOrUpdate",
    method: "post",
    data,
  });
}
/*详情*/
export function queryDetails(data) {
  return request({
    url: "/icps/system/sign/basics/mixProportion/queryDetails",
    method: "post",
    data,
  });
}
/*删除*/
export function deletes(data) {
  return request({
    url: "/icps/system/sign/basics/mixProportion/deletes",
    method: "post",
    data,
  });
}
/*取历史修改记录*/
export function queryLogList(data) {
  return request({
    url: "/icps/system/sign/basics/mixProportion/queryLogList",
    method: "post",
    data,
  });
}
/*根据记录list配合比id获取详细列表*/
export function queryDateList(data) {
  return request({
    url: "/icps/system/sign/basics/mixProportion/queryDateList",
    method: "post",
    data,
  });
}